import { type SvgIconProps } from '@common/components/svgs/props';

function IconAttachment(
  { size = 24, color = 'scheme-feedback-text-color', ...rest }: Readonly<SvgIconProps>,
) {
  return (
    <svg
      {...rest}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="svg-Attachment"
    >
      <path
        d="M2.5 10C2.5 6.96243 4.96243 4.5 8 4.5H13C16.0376 4.5 18.5 6.96243 18.5 10C18.5 13.0376 16.0376 15.5 13 15.5H8.99982C8.68597 15.0822 8.5 14.5628 8.5 14C8.5 13.8288 8.51722 13.6616 8.55001 13.5H13C14.933 13.5 16.5 11.933 16.5 10C16.5 8.067 14.933 6.5 13 6.5H8C6.067 6.5 4.5 8.067 4.5 10C4.5 10.6077 4.65487 11.1792 4.92731 11.6772C4.65124 12.3986 4.5 13.1816 4.5 14C4.5 14.0826 4.50154 14.1648 4.50459 14.2466C3.28045 13.2379 2.5 11.7101 2.5 10Z"
        fill={`var(--${color})`}
      />
      <path
        d="M11 8.5H15.0002C15.314 8.91783 15.5 9.4372 15.5 10C15.5 10.1712 15.4828 10.3384 15.45 10.5H11C9.067 10.5 7.5 12.067 7.5 14C7.5 15.933 9.067 17.5 11 17.5H16C17.933 17.5 19.5 15.933 19.5 14C19.5 13.3923 19.3451 12.8208 19.0727 12.3228C19.3488 11.6014 19.5 10.8184 19.5 10C19.5 9.91742 19.4985 9.83521 19.4954 9.75338C20.7196 10.7621 21.5 12.2899 21.5 14C21.5 17.0376 19.0376 19.5 16 19.5H11C7.96243 19.5 5.5 17.0376 5.5 14C5.5 10.9624 7.96243 8.5 11 8.5Z"
        fill={`var(--${color})`}
      />
    </svg>
  );
}

IconAttachment.displayName = 'Attachment';

export default IconAttachment;
